
import React, { createContext, useContext, useState, useEffect } from 'react';
import {
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  createUserWithEmailAndPassword
} from 'firebase/auth';
import { auth, db } from '../firebase/config';
import { collection, query, where, getDocs } from 'firebase/firestore';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);

  // Sign up function
  function signup(email, password) {
    return createUserWithEmailAndPassword(auth, email, password);
  }

  // Login function
  function login(email, password) {
    return signInWithEmailAndPassword(auth, email, password);
  }

  // Logout function
  function logout() {
    return signOut(auth);
  }

  // Fetch user role from Firestore
  const fetchUserRole = async (user) => {
    if (!user) {
      setUserRole(null);
      return;
    }

    try {
      // Check drivers first
      const driverSnapshot = await getDocs(
        query(collection(db, 'drivers'), where('uid', '==', user.uid))
      );
      if (!driverSnapshot.empty) {
        setUserRole('driver');
        return;
      }

      // Check admins collection explicitly
      const adminSnapshot = await getDocs(
        query(collection(db, 'admins'), where('uid', '==', user.uid))
      );
      if (!adminSnapshot.empty) {
        setUserRole('admin');
        return;
      }

      // Not found in either — no access
      setUserRole('unauthorized');
    } catch (error) {
      console.error('Error fetching user role:', error);
      setUserRole('unauthorized');
    }
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setCurrentUser(user);
      await fetchUserRole(user);
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const value = {
    currentUser,
    userRole,
    login,
    signup,
    logout
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}